<script setup>
import {useAuthStore} from '@/stores';
import { useLaunchDarkly } from '@/composables/useLaunchDarkly'

const authStore = useAuthStore();
import AppPage from "@/components/AppPage.vue";
import WallOfFame from "@/components/WallOfFame.vue";

// Example feature flag usage with safe fallback
const { useFlag } = useLaunchDarkly()
const showWelcomeBanner = useFlag('show-welcome-banner', false)

</script>
<template>
  <AppPage title="Wall of Fame" :loaded="true">
    <!-- Example feature flag usage -->
    <div v-if="showWelcomeBanner" class="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
      <h3 class="text-lg font-semibold text-blue-800 mb-2">🎉 Welcome to hOS People!</h3>
      <p class="text-blue-700">
        This welcome banner is controlled by the <code class="bg-blue-100 px-1 rounded">show-welcome-banner</code> feature flag.
        Create this flag in LaunchDarkly and toggle it to see this message appear or disappear in real-time!
      </p>
    </div>
    
    <WallOfFame/>
  </AppPage>
</template>
